<template>
    <li class="nav-item text-nowrap ml-3 mr-3" style="cursor: pointer; top: 6px; position: relative; font-size: 1rem;">
        <span @click.stop="startTimer()" class="material-symbols-outlined h2 mb-0"> timer </span>
        <div style="display: inline-block; position: relative; top: -4px;">
            <span v-tooltip :title="(activeStamp?.project ? activeStamp?.project?.client.name + ' - ' + activeStamp?.project?.name + ' ' + activeStamp?.subproject?.name + ' ' + ((activeStamp?.comment_from_manual) ? ' (' + activeStamp?.comment_from_manual + ') ' : '') : '')" @click.stop="startTimer()" id="manualtimetracking-clock">{{ timeString }}</span>
            <span @click.stop="startTimer()" v-if="time == 0" class="material-symbols-outlined text-success" style="top: 3px; font-size: 18px;">play_circle</span>
            <a v-if="time > 0" href="/manualtimetracking/stop" class="material-symbols-outlined text-danger" style="top: 3px; font-size: 18px;">stop_circle</a>
        </div>
    </li>

    <Teleport to="body">
        <div class="modal" tabindex="-1" id="manualtimetrackingmodalStart">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4>{{ $trans.get("__JSON__.Add manual time tracking stamp") }}</h4>
                    </div>
                    <div class="modal-body" v-if="timetrackingactive">
                        <div v-if="errors" class="alert alert-danger" role="alert">
                            <div v-for="(v, k) in errors" :key="k">
                                <p v-for="error in v" :key="error">
                                    {{ error }}
                                </p>
                            </div>
                        </div>
                        <div class="row" v-if="!client && !project && !subproject">
                            <div class="mb-3 col-6 pt-3" v-if="favourites">
                                <label for="clientId">{{ $trans.get("__JSON__.Favourites") }}</label>
                            </div>
                            <div class="d-flex flex-wrap pb-3" style="gap: 20px; border-bottom: 1px solid lightgray;">
                                <div @click="setFav(fav.project.client.id, fav.project.id, fav.subproject ? fav.subproject.id : null)" class="mts-client d-flex" style="width: 18%; min-height: 125px; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px; flex-direction: column; justify-content: space-between;" v-for="fav in favourites">
                                    <div class="d-flex" style="height: 100%; align-items: center; justify-content: center; border: 1px solid lightgray; border-top-right-radius: 5px; border-top-left-radius: 5px; padding: 3px;">
                                        <img v-if="fav.project.client.logoname" :src="'/images/' + fav.project.client.logoname" style="padding-left: 5px; width: 50%;">
                                        <span class="material-symbols-outlined" :style="'text-align:center; width: 50%; font-size: 3rem; color: ' + fav.project.color + ';'">{{ fav.project.projecttype?.icon ? fav.project.projecttype?.icon : 'hide_source' }}</span>
                                    </div>
                                    <span class="clientnamelogo" style="background-color: black; color:white; font-size: 0.6rem; padding: 5px; border-bottom-right-radius: 5px; border-bottom-left-radius: 5px; text-align: center;">{{ fav.project.client.name }} - {{ fav.project.name }} {{ fav.subproject ? ' - ' + fav.subproject.name : '' }}</span>
                                </div>
                            </div>
                            <div class="mb-3 col-6 pt-3">
                                <label for="clientId">{{ $trans.get("__JSON__.Client") }}</label>
                            </div>
                            <div class="d-flex flex-wrap pt-1" style="gap: 20px;">
                                <div @click="setClient(client.id)" class="mts-client d-flex" style="width: 10%; min-height: 125px; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px; flex-direction: column; justify-content: space-between;" v-for="client in clients"><div class="d-flex" style="height: 100%; align-items: center; justify-content: center; border: 1px solid lightgray; border-top-right-radius: 5px; border-top-left-radius: 5px; padding: 3px;"><img v-if="client.logoname" :src="'/images/' + client.logoname" style="width: 100%;"></div><span class="clientnamelogo" style="background-color: black; color:white; font-size: 0.6rem; padding: 5px; border-bottom-right-radius: 5px; border-bottom-left-radius: 5px; text-align: center;">{{ client.name }}</span></div>
                            </div>
                            <div class="mb-3 col-12 mt-3">
                                <a v-if="!showAllClients" @click.stop="toggleAllClients" class="btn btn-light">{{ $trans.get("__JSON__.Show all clients") }}</a>
                                <a v-if="showAllClients" @click.stop="toggleAllClients" class="btn btn-light">{{ $trans.get("__JSON__.Hide all clients") }}</a>
                            </div>
                        </div>
                        <div class="row" v-if="client && !project && !subproject">
                            <div class="mb-3 col-6">
                                <label for="projectId">{{ $trans.get("__JSON__.Project") }}</label>
                            </div>
                            <div class="d-flex flex-wrap" style="gap: 20px;">
                                <div @click="setProject(project)" class="mts-client d-flex" style="width: 10%; min-height: 125px; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px; flex-direction: column; justify-content: space-between;" v-for="project in projects"><div class="d-flex" :style="'height: 100%; align-items: center; justify-content: center; border: 1px solid lightgray; border-top-right-radius: 5px; border-top-left-radius: 5px; padding: 3px; background-color: #ffffff;'"><span class="material-symbols-outlined" :style="'font-size: 3rem; color: ' + project.color + ';'">{{ project?.projecttype?.icon ? project.projecttype.icon : 'hide_source' }}</span></div><span class="clientnamelogo" style="background-color: black; color:white; font-size: 0.6rem; padding: 5px; border-bottom-right-radius: 5px; border-bottom-left-radius: 5px; text-align: center;">{{ project.name }}</span></div>
                            </div>
                            <div class="mb-3 col-12 mt-3">
                                <a @click.stop="reset" class="btn btn-light">{{ $trans.get("__JSON__.back") }}</a>
                            </div>
                        </div>
                        <div class="row" v-if="client && project && hasSubProjects && !subproject">
                            <div class="mb-3 col-6">
                                <label for="subProjectId">{{ $trans.get("__JSON__.Subproject") }}</label>
                            </div>
                            <div class="d-flex flex-wrap" style="gap: 20px;">
                                <div @click="setSubProject(subproject.id)" class="mts-client d-flex" style="width: 10%; min-height: 125px; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px; flex-direction: column; justify-content: space-between;" v-for="subproject in subprojects"><div class="d-flex" :style="'height: 100%; align-items: center; justify-content: center; border: 1px solid lightgray; border-top-right-radius: 5px; border-top-left-radius: 5px; padding: 3px; background-color: #ffffff;'"><span class="material-symbols-outlined" style="font-size: 3rem; color: #123456;">hide_source</span></div><span class="clientnamelogo" style="background-color: black; color:white; font-size: 0.6rem; padding: 5px; border-bottom-right-radius: 5px; border-bottom-left-radius: 5px; text-align: center;">{{ subproject.name }}</span></div>
                            </div>
                            <div class="mb-3 col-12 mt-3">
                                <a @click.stop="reset" class="btn btn-light">{{ $trans.get("__JSON__.back") }}</a>
                            </div>
                        </div>
                        <div class="row" v-if="client && project && (subproject || !hasSubProjects)">
                            <div class="mb-3 col-6">
                                <label for="location">{{ $trans.get("__JSON__.Location") }}</label>
                                <select class="form-control" v-model="location" name="location_id" id="location_id">
                                    <option value="0" selected>Choose location</option>
                                    <option v-for="item in locations" :key="item.id" :value="item.id">
                                        {{ item.name }}
                                    </option>
                                </select>
                                <label for="comment">{{ $trans.get("__JSON__.Comment") }}</label>
                                <textarea class="form-control" v-model="comment" id="comment"></textarea>
                            </div>
                            <div class="mb-3 col-12">
                                <a @click.stop="reset" class="btn btn-light">{{ $trans.get("__JSON__.back") }}</a>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                            {{ $trans.get("__JSON__.Close") }}
                        </button>
                        <button type="button" class="btn btn-primary" @click="saveNewStamp">
                            {{ $trans.get("__JSON__.Save") }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
    <Teleport to="body">
        <div class="modal" tabindex="-1" id="manualtimetrackingmodalInfo">
            <div class="modal-dialog modal-md">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4>{{ $trans.get("__JSON__.Add manual time tracking stamp") }}</h4>
                    </div>
                    <div class="modal-body">
                        Die Stempelzeit für {{ referenceStamp }} wurde beendet. Wenn der aktuell laufende Zeiteintrag beendet wird, wird die Stempelzeit für {{ referenceStamp }} wieder aufgenommen!
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                            {{ $trans.get("__JSON__.Close") }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
import { ref, watch } from "vue";

import getClients from "../composables/getClients";
import getProjects from "../composables/getProjects";
import getFavourites from "../composables/getFavourites";

import { formatDateTime } from "../formatdate";

export default {
    name: "ManualTimeTrackingHead",
    props: {
        stamp: Object,
        teamid: Number,
        employeeid: Number,
        locations: Object,
    },
    setup() {
        const { clients, clients_error, loadClients } = getClients();
        const { projects, projects_error, loadProjects } = getProjects();
        const { favourites, favourites_error, loadFavourites } = getFavourites();
        return {
            clients,
            projects,
            clients_error,
            projects_error,
            loadClients,
            loadProjects,
            favourites,
            favourites_error,
            loadFavourites,
        }
    },
    watch: {
        time: function() {
            if (this.activeStamp.intime) {
                var hours = (this.time - (this.time % 3600)) / 3600;
                var minutes = (this.time - (hours * 3600) - (this.time % 60)) / 60;
                var seconds = this.time % 60;
                this.timeString = (hours < 10 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
            }
        },
        showAllClients: {
            handler() {
                if (this.showAllClients) {
                    this.loadClients([['has_projects', true]]);
                } else {
                    this.loadClients([['team_id', this.teamid], ['has_projects', true]]);
                }
            }
        },
    },
    data() {
        return {
            time: 0,
            timeString: '',
            client: null,
            project: null,
            errors: null,
            showAllClients: false,
            comment: '',
            referenceStamp: null,
            location: 0,
            subproject: null,
            hasSubProjects: false,
            subprojects: [],
            timetrackingactive: false,
        }
    },
    created() {
        this.activeStamp = this.stamp;
        this.timeString = '00:00';
        if (this.activeStamp.intime) {
            var now = new Date().getTime();
            var intime = new Date(this.activeStamp.intime).getTime();
            this.time = ((now - intime) - ((now - intime) % 1000)) / 1000;
        }
    },
    mounted: function () {
        if (this.activeStamp.intime) {
            var worker = new Worker('/js/timer.js');
            worker.onmessage = () => {
                this.time++;
            };
        }
    },
    methods: {
        startTimer() {
            if (!this.activeStamp.intime) {
                this.reset();
                this.timetrackingactive = true;
                this.loadClients([['team_id', this.teamid], ['has_projects', true]]);
                this.loadFavourites();
                $("#manualtimetrackingmodalStart").modal("show");
            }
        },
        toggleAllClients() {
            this.showAllClients = !this.showAllClients;
        },
        setClient(clientId) {
            this.client = clientId;
            this.loadProjects([['client_id', this.client]]);
        },
        setProject(project) {
            this.project = project.id;
            this.hasSubProjects = false;
            this.subprojects = [];
            if (project.subprojects.length > 0) {
                this.hasSubProjects = true;
                this.subprojects = project.subprojects;
            }
        },
        setSubProject(subProjectId) {
            this.subproject = subProjectId;
        },
        reset() {
            this.showAllClients = false;
            this.client = null;
            this.project = null;
            this.subproject = null;
            this.hasSubProjects = false;
            this.location = 0;
        },
        saveNewStamp() {
            axios
                .post("/api/stamps", {
                    id: null,
                    device_id: 0,
                    location_id: this.location,
                    project_id: this.project,
                    subproject_id: this.subproject,
                    employee_id: this.employeeid,
                    intime: formatDateTime(new Date()) + ':' + new Date().getSeconds(),
                    outtime: null,
                    read_only: false,
                    comment_from_manual: this.comment,
                    from_manual_time_tracking: true
                })
                .then((resp) => {
                    $("#manualtimetrackingmodalStart").modal("hide");
                    if (resp.data.reference_stamp_id > 0) {
                        this.referenceStamp = resp.data.referencestamp.client.name + ' - ' + resp.data.referencestamp.project.name;
                        if (resp.data.referencestamp.subproject) {
                            this.referenceStamp += ' - ' + resp.data.referencestamp.subproject.name;
                        }
                        $('#manualtimetrackingmodalInfo').modal("show");
                    } else {
                        this.referenceStamp = null;
                    }
                    this.refreshStamp();
                })
                .catch((error) => {
                    console.log(error);
                    this.errors = error.response.data.errors;
                });
        },
        refreshStamp() {
            axios
                .get("/api/manualtimetracking/getActiveStamp/")
                .then((resp) => {
                    this.activeStamp = resp.data;
                    if (this.activeStamp.intime) {
                        var now = new Date().getTime();
                        var intime = new Date(this.activeStamp.intime).getTime();
                        this.time = ((now - intime) - ((now - intime) % 1000)) / 1000;
                        if (this.activeStamp.intime) {
                            var worker = new Worker('/js/timer.js');
                            worker.onmessage = () => {
                                this.time++;
                            };
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.errors = error.response.data.errors;
                });
        },
        setFav(clientId, projectId, subProjectId) {
            this.client = clientId;
            this.project = projectId;
            this.subproject = subProjectId;
        }
    }
}
</script>

<style lang="scss"></style>
